<template>
    <UInput
        v-model="value"
        v-bind="options"
        :type="showPassword ? 'text' : 'password'"
        :ui="{ icon: { trailing: { pointer: '' } } }"
    >
        <template #trailing>
            <UButton
                v-show="true"
                color="gray"
                variant="link"
                :icon="fieldIcon"
                :padded="false"
                size="md"
                @click="handleShowPassword"
            />
        </template>
    </UInput>
</template>

<script lang="ts" setup>
const value = defineModel({ required: true, type: String });

const props = defineProps({
    options: Object,
});

const showPassword = shallowRef(false);

const fieldIcon = computed(() => {
    return showPassword.value ? "i-solar-password-outline" : "i-solar-password-minimalistic-input-line-duotone";
});

function handleShowPassword() {
    showPassword.value = !showPassword.value;
}
</script>

<style></style>
